module.exports = __webpack_public_path__ + "static/media/mcc_white.bfcc4dfc.png";